import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import { camelCase } from 'lodash';
import enableInlineVideo from 'iphone-inline-video';
import { performance, app } from '../core/core';
import EventEmitter from '../core/eventemitter';
import { isElement, cloneDeep, Defer } from '../core/utils';
/*----------------------------------------------------*/
// Constants & variables

/*----------------------------------------------------*/

var VIDEO_EVENTS = {
  loadstart: 'onLoadStart',
  loadedmetadata: 'onLoadedMetaData',
  progress: 'onProgress',
  canplay: 'onCanPlay',
  canplaythrough: 'onCanPlayThrough',
  playing: 'onPlaying',
  play: 'onPlay',
  pause: 'onPause',
  ended: 'onEnded',
  error: 'onError',
  abort: 'onAbort',
  timeupdate: 'onTimeUpdate',
  seeking: 'onSeeking',
  seeked: 'onSeeked',
  volumechange: 'onVolumeChange',
  waiting: 'onWaiting'
};
var defaults = {
  autoplay: false,
  controls: false,
  muted: true,
  loop: false,
  inline: true,
  volume: 1
};
var properties = {
  debug: false,
  video: null,
  sources: [],
  initialized: false,
  playing: false,
  iosautoplay: false,
  width: 0,
  height: 0,
  duration: 0,
  dataloaded: null,
  canplay: null
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Video = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Video, _EventEmitter);

  var _super = _createSuper(Video);

  function Video(element) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(null);

    _classCallCheck(this, Video);

    // element
    var $element = isElement($d(element));

    if (typeof $element === 'undefined' || !$element) {
      throw new Error('Passed element is not a valid element');
    } // Make sure the element is a video element or find one inside


    var video;

    if ($element.prop('tagName') !== 'VIDEO') {
      video = $element.find('video');

      if (!video.length) {
        throw new Error('No video element was found');
      }

      video = video.get(0);
    } else {
      video = $element.get(0);
    } // defaults


    var defaultAttr = function defaultAttr(attribute) {
      var attr = video.getAttribute(attribute);
      return typeof attr !== 'undefined' && (attr === true || attr === '' || attr === attribute);
    };

    var params = {
      autoplay: defaultAttr('autoplay') || defaults.autoplay,
      controls: defaultAttr('controls') || defaults.controls,
      muted: defaultAttr('muted') || defaults.muted,
      loop: defaultAttr('loop') || defaults.loop,
      inline: defaultAttr('playsinline') || defaults.inline
    }; // options

    var opts = Object.assign(Object.create(null), defaults, params, options);
    _this = _super.call(this, opts); // properties

    Object.assign(_assertThisInitialized(_this), cloneDeep(properties));
    _this.options = opts;
    _this.video = video; // remove useless prototypes

    if (typeof Object.setPrototypeOf !== 'undefined') {
      Object.setPrototypeOf(_this.options, null);
    } // attach


    video.videoapi = _assertThisInitialized(_this); // debug

    if (typeof _this.options.debug !== 'undefined') {
      _this.debug = _this.options.debug;
    }

    if (_this.debug) {
      console.log("%Service [HTML5 Video] %c(".concat(performance.now(), "s) : \r\n"), 'color: #FCBF49; font-weight: bold;', 'color: black;', _assertThisInitialized(_this));
    } // setup


    _this.setup();

    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Video, [{
    key: "destroy",
    value: function destroy() {
      delete this.video.videoapi; // promises

      if (this.dataloaded && this.dataloaded.isPending()) {
        this.dataloaded.reject();
        this.dataloaded = null;
      }

      if (this.canplay && this.canplay.isPending()) {
        this.canplay.reject();
        this.canplay = null;
      } // events


      this.removeAllListeners();
      this.unbindEvents();
    } // Methods
    // --------------------------------------------------

  }, {
    key: "setup",
    value: function setup() {
      var _this2 = this;

      // video properties
      this.video.volume = this.options.volume;
      this.video.controls = this.options.controls === true;
      this.video.muted = this.options.muted === true;
      this.video.loop = this.options.loop === true;
      this.video.inline = this.options.inline === true; // promises

      this.dataloaded = new Defer();
      this.canplay = new Defer(); // check devices stuff

      var device = app().browser.getPlatform(); // iOS devices hack to enable video autoplay & inline mode

      if (typeof device.model !== 'undefined' && ['iphone', 'ipad'].indexOf(device.model.toLowerCase()) > -1) {
        var osversion = app().browser.getOSVersion();
        var rc = parseInt(osversion.split('.')[0], 10); // we can't do anything for iOS < 8 :(

        if (rc < 8) {
          setTimeout(function () {
            _this2.onAbort();

            _this2.emit('notsupported');
          }, 0);
          return;
        } // make sure that the "playsinline" mode is not supported


        if (typeof window.matchMedia !== 'undefined' && !window.matchMedia('(-webkit-video-playable-inline)').matches) {
          this.iosautoplay = true;
        }
      }

      this.canplay.then(function () {
        _this2.onReady();
      }); // bind events

      this.bindEvents(); // force video loading

      this.video.load(); // if ( this.options.autoplay ) {
      //     this.video.play();
      // }
    } // Controls
    // --------------------------------------------------

  }, {
    key: "play",
    value: function play() {
      var _this3 = this;

      var promise = new Defer();
      this.canplay.then(function () {
        var p = _this3.video.play();

        if (typeof p !== 'undefined') {
          p.then(function () {
            return promise.resolve();
          }).catch(function () {
            return promise.reject();
          });
        } else {
          promise.resolve();
        }
      });
      return promise;
    }
  }, {
    key: "pause",
    value: function pause() {
      this.video.pause();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.play();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.pause();
      this.seek(0);
    }
  }, {
    key: "seek",
    value: function seek(time) {
      this.video.currentTime = time;
    }
  }, {
    key: "mute",
    value: function mute() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.video.muted = state;
    } // Helpers
    // --------------------------------------------------

  }, {
    key: "getDuration",
    value: function getDuration() {
      this.duration = this.video.duration;
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.video.currentTime;
    }
  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.video.muted;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      var volume = this.video.volume;
      var muted = this.getMuted();

      if (volume !== 0 && muted) {
        volume = 0;
      }

      return volume;
    } // Events
    // --------------------------------------------------

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this4 = this;

      Object.keys(VIDEO_EVENTS).forEach(function (event) {
        var handler = VIDEO_EVENTS[event];
        var boundMethod = camelCase("bound".concat(handler));
        _this4[boundMethod] = _this4[handler].bind(_this4);

        _this4.video.addEventListener(event, _this4[boundMethod]);
      });
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      var _this5 = this;

      Object.keys(VIDEO_EVENTS).forEach(function (event) {
        var handler = VIDEO_EVENTS[event];
        var boundMethod = camelCase("bound".concat(handler));

        _this5.video.removeEventListener(event, _this5[boundMethod]);
      });
    }
  }, {
    key: "onReady",
    value: function onReady() {
      if (this.debug) {
        console.log('ready');
      }

      if (!this.initialized) {
        this.width = this.video.videoWidth;
        this.height = this.video.videoHeight;
        this.duration = this.video.duration;

        if (this.options.autoplay === true) {
          this.play();
        }

        this.initialized = true;
      }

      this.emit('ready', this);
    }
  }, {
    key: "onLoadStart",
    value: function onLoadStart() {
      if (this.debug) {
        console.log('loadstart');
      }

      if (this.iosautoplay) {
        enableInlineVideo(this.video, {
          everywhere: true
        });
      }

      this.emit('loadstart');
    }
  }, {
    key: "onLoadedMetaData",
    value: function onLoadedMetaData() {
      if (this.debug) {
        console.log('loadedmetadata');
      }

      this.dataloaded.resolve();
      this.emit('loadedmetadata');
    }
  }, {
    key: "onProgress",
    value: function onProgress() {
      if (this.debug) {
        console.log('progress');
      }

      this.emit('progress');
    }
  }, {
    key: "onCanPlay",
    value: function onCanPlay() {
      if (this.debug) {
        console.log('canplay');
      }

      this.dataloaded.resolve();
      this.canplay.resolve();
      this.emit('canplay');
    }
  }, {
    key: "onCanPlayThrough",
    value: function onCanPlayThrough() {
      if (this.debug) {
        console.log('canplaythrough');
      }

      this.emit('canplaythrough');
    }
  }, {
    key: "onPlaying",
    value: function onPlaying() {
      if (this.debug) {
        console.log('playing');
      }

      this.playing = true;
      this.emit('playing');
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      if (this.debug) {
        console.log('play');
      }

      this.playing = true;
      this.emit('play');
    }
  }, {
    key: "onPause",
    value: function onPause() {
      if (this.debug) {
        console.log('pause');
      }

      this.playing = false;
      this.emit('pause');
    }
  }, {
    key: "onEnded",
    value: function onEnded() {
      if (this.debug) {
        console.log('ended');
      }

      this.playing = false;
      this.emit('ended');
    }
  }, {
    key: "onError",
    value: function onError() {
      if (this.debug) {
        console.log('error');
      }

      this.playing = false;
      this.dataloaded.reject();
      this.canplay.reject();
      this.emit('error');
    }
  }, {
    key: "onAbort",
    value: function onAbort() {
      if (this.debug) {
        console.log('abort');
      }

      this.playing = false;

      if (this.initialized === true) {
        this.dataloaded.reject();
        this.canplay.reject();
      }

      this.emit('abort');
    }
  }, {
    key: "onTimeUpdate",
    value: function onTimeUpdate() {
      if (this.debug) {
        console.log('timeupdate');
      }

      var time = this.getCurrentTime();
      var duration = this.getDuration();
      this.emit('timeupdate', time, duration);
    }
  }, {
    key: "onSeeking",
    value: function onSeeking() {
      if (this.debug) {
        console.log('seeking');
      }

      this.playing = false;
      this.emit('seeking');
    }
  }, {
    key: "onSeeked",
    value: function onSeeked() {
      if (this.debug) {
        console.log('seeked');
      }

      this.emit('seeked');
    }
  }, {
    key: "onVolumeChange",
    value: function onVolumeChange() {
      if (this.debug) {
        console.log('volumechange');
      }

      var volume = this.getVolume();
      this.emit('volumechange', volume);
    }
  }, {
    key: "onWaiting",
    value: function onWaiting() {
      if (this.debug) {
        console.log('waiting');
      }

      this.emit('waiting');
    }
  }]);

  return Video;
}(EventEmitter);

export default Video;

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}